import React, { useEffect, useState } from "react";
import "./index.css";
import { Button, Form, Input, notification, Typography, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useForm } from "antd/es/form/Form";
import { getUser, updateUser } from "../../../Services/UserProfileServices";
import CommonLayout from "../CommonLayout";
import User_Profile_Header from "../../../Assets/user_profile_header.png";
import { UserRespose } from "../../../redux/Reducer/userReducer";
import { userInformation } from "../../../redux/actions";
import store from "../../../redux/store";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { translation } from "../../../i18n/translationConstant";

const UserProfile: React.FC<{
  setReduxUser: (user: any) => void;
}> = ({ setReduxUser }) => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    vuaId: "",
  });
  const [changedValues, setChangedValues] = useState({
    firstName: "",
    lastName: "",
  });
  const [isProfileChanged, setIsProfileChanged] = useState(false);

  const { t } = useTranslation();
  const [form] = useForm();

  useEffect(() => {
    getUser().then((res) => setUser(res.data));
  }, []);

  useEffect(() => {
    setChangedValues({ firstName: user.firstName, lastName: user.lastName });
    form.setFieldsValue({ firstName: user.firstName, lastName: user.lastName });
  }, [user, form]);

  const updateUserInfo = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsProfileChanged(true);
    event.target.id === "firstName"
      ? setChangedValues((old) => ({ ...old, firstName: event.target.value }))
      : setChangedValues((old) => ({ ...old, lastName: event.target.value }));
  };
  const onNameChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^A-Za-z]+/g, "");
  };
  const updateUserData = (values: any) => {
    updateUser(values.firstName, values.lastName).then(() => {
      notification.success({
        message: t("msgUserProfileSuccess"),
      });
      setReduxUser({
        firstName: changedValues.firstName,
        lastName: changedValues.lastName,
        mobileNumber: user.mobileNumber,
        vuaId: user.vuaId,
      });
    });
  };

  const [showVuaId, setShowVuaId] = useState(false);
  const [showMobileNumber, setShowMobileNumber] = useState(false);

  return (
    <CommonLayout imageUrl={User_Profile_Header} title={t(translation.lblUserProfile)}>
      <div className="row justifyCenter width60 marginTop30 overflowAuto">
        <Form
          form={form}
          layout="inline"
          name="basic"
          autoComplete="off"
          scrollToFirstError={true}
          onFinish={updateUserData}
        >
          <div className="row justifyCenter ">
            <Form.Item
              className="profileFormItem"
              name="firstName"
              rules={[
                {
                  required: true,
                  message: t("errorRequiredFirstName"),
                },
              ]}
            >
              <div>
                <Typography.Text className={`inputLabels`}>
                  {t("lblFirstName")}
                </Typography.Text>

                <Input
                  className="formInput"
                  onInput={onNameChange}
                  id="firstName"
                  value={changedValues.firstName}
                  onChange={updateUserInfo}
                />
              </div>
            </Form.Item>

            <Form.Item
              className="profileFormItem"
              name="lastName"
              rules={[
                {
                  required: true,
                  message: t("errorRequiredLastName"),
                },
              ]}
            >
              <div>
                <Typography.Text>{t("lblLastName")}</Typography.Text>
                <Input
                  id="lastName"
                  onInput={onNameChange}
                  value={changedValues.lastName}
                  onChange={updateUserInfo}
                  className="formInput"
                />
              </div>
            </Form.Item>
            <Form.Item className="profileFormItem">
              <div>
                <Typography.Text>{t("lblUserName")}</Typography.Text>
                <Input
                  id="vuaid"
                  value={user.vuaId}
                  type={showVuaId ? "text" : "password"} // Set input type to "password" or "text" based on showPassword state
                  readOnly
                  className="formInput"
                  onChange={(e) => setUser({ ...user, vuaId: e.target.value })}
                  onClick={() => setShowVuaId(!showVuaId)}
                />
              </div>
            </Form.Item>
            <Form.Item className="profileFormItem">
              <div>
                <Typography.Text>{t("lblMobileNumber")}</Typography.Text>
                <Input
                  id="mobileNumber"
                  value={user.mobileNumber}
                  type={showMobileNumber ? "text" : "password"} // Set input type to "password" or "text" based on showPassword state
                  className="formInput"
                  readOnly
                  onChange={(e) => setUser({ ...user, mobileNumber: e.target.value })}
                  onClick={() => setShowMobileNumber(!showMobileNumber)}
                />
              </div>
            </Form.Item>
          </div>

          <div className="row justifyCenter marginTop60 width100 ">
            <Button
              htmlType="submit"
              className="profileSubmitButton"
              disabled={!isProfileChanged}
            >
              {t("lblUpdateDetails")}
            </Button>
          </div>
        </Form>
      </div>
    </CommonLayout>
  );
};

const mapDispatchToProps = () => {
  return {
    setReduxUser: (changedUser: UserRespose) =>
      store.dispatch(userInformation(changedUser)),
  };
};

export default connect(mapDispatchToProps)(UserProfile);
